import Layout from '@/layout'
import EmptyLayout from '@/layout/EmptyLayout'
import FullLayout from '@/layout/FullLayout'

const upmsRouter = {
  path: '/upms',
  component: Layout,
  name: 'upms',
  meta: { title: '管理系统' },
  children: [
    {
      path: '/upms/systemSetting/Standing',
      redirect: '/upms/systemSetting/Standing/ProjectManage',
      name: 'systemSettingStanding',
      component: FullLayout,
      meta: { title: '台账管理' },
      children: [
        {
          path: 'ProjectManage',
          name: 'ProjectManage',
          component: () => import('@/views/upms/deviceManage/ProjectManage'),
          meta: { title: '项目管理', activeMenu: '/upms/systemSetting/Standing' },
          hidden: true
        },
        {
          path: 'Deviceattribute',
          name: 'Deviceattribute',
          component: () => import('@/views/upms/deviceManage/Deviceattribute'),
          meta: { title: '设备属性管理', activeMenu: '/upms/systemSetting/Standing' },
          hidden: true
        }, {
          path: 'Equipmentclassification',
          name: 'Equipmentclassification',
          component: () => import('@/views/upms/deviceManage/Equipmentclassification'),
          meta: { title: '设备分类管理', activeMenu: '/upms/systemSetting/Standing' },
          hidden: true
        },
        {
          path: 'Itemizedmanagement',
          name: 'Itemizedmanagement',
          meta: { title: '项目分项管理', activeMenu: '/upms/systemSetting/Standing' },
          component: () => import('@/views/upms/deviceManage/Itemizedmanagement'),
          hidden: true
        }, {
          path: 'Pzoningmanagement',
          name: 'Pzoningmanagement',
          meta: { title: '项目分区管理', activeMenu: '/upms/systemSetting/Standing' },
          component: () => import('@/views/upms/deviceManage/Pzoningmanagement'),
          hidden: true
        }, {
          path: 'groupingmanagement',
          name: 'groupingmanagement',
          meta: { title: '项目设备分组管理', activeMenu: '/upms/systemSetting/Standing' },
          component: () => import('@/views/upms/deviceManage/groupingmanagement'),
          hidden: true
        }, {
          path: 'YicituEdit',
          name: 'YicituEdit',
          component: () => import('@/views/business/yicijiexiantu/edit/index'),
          meta: { title: '一次图编辑', activeMenu: '/upms/systemSetting/Standing' },
          hidden: true
        }
      ]
    },
    {
      path: '/upms/systemSetting/adminSetting',
      name: 'adminSetting',
      component: FullLayout,
      meta: { title: '系统管理' },
      redirect: '/upms/systemSetting/adminSetting/UserManage',
      children: [
        {
          path: 'mechanism',
          name: 'mechanism',
          component: () => import('@/views/upms/deviceManage/mechanism'),
          meta: { title: '机构管理', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'RoleManage',
          name: 'RoleManage',
          component: () => import('@/views/upms/deviceManage/role'),
          meta: { title: '角色管理', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'post',
          name: 'post',
          component: () => import('@/views/upms/deviceManage/post'),
          meta: { title: '岗位管理', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'UserManage',
          name: 'UserManage',
          component: () => import('@/views/upms/deviceManage/user'),
          meta: { title: '用户管理', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'region',
          name: 'region',
          component: () => import('@/views/upms/deviceManage/region'),
          meta: { title: '区域管理', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'dataDictionary',
          name: 'dataDictionary',
          component: () => import('@/views/upms/deviceManage/dataDictionary'),
          meta: { title: '数据字典', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'Userarea',
          name: 'Userarea',
          component: () => import('@/views/upms/deviceManage/Userarea'),
          meta: { title: '用户区域分配', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        },
        {
          path: 'SystemMenu',
          name: 'SystemMenu',
          component: () => import('@/views/upms/deviceManage/SystemMenu'),
          meta: { title: '菜单管理', activeMenu: '/upms/systemSetting/adminSetting' },
          hidden: true
        }
      ]
    }
  ]
}
export default upmsRouter

